import { render, staticRenderFns } from "./GameTile.vue?vue&type=template&id=661ed3d2&scoped=true&"
import script from "./GameTile.vue?vue&type=script&lang=js&"
export * from "./GameTile.vue?vue&type=script&lang=js&"
import style0 from "./GameTile.vue?vue&type=style&index=0&id=661ed3d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661ed3d2",
  null
  
)

export default component.exports